<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button autoHide="true" data-cy="myPairedAgents-hdr-menuBtn"></ion-menu-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <app-profile-component data-cy="myPairedAgents-hdr-profileBtn" (click)="openMyProfile()"></app-profile-component>

      <ion-button (click)="openHelp()" data-cy="myPairedAgents-hdr-helpBtn">
        <ion-icon slot="icon-only" name="help-circle-sharp"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title *ngIf="userData?.role !== 'agentAdmin'" data-cy="myPairedAgents-hdr-title">Paired Agents</ion-title>
    <ion-title *ngIf="userData?.role === 'agentAdmin'" data-cy="myPairedAgents-hdr-title">Agents</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!-- ACTIVE SUBSCRIPTION VIEW -->
  <div id="firstPairedAgentsDiv" class="myPairedAgents" *ngIf="!showRefresh">

    <!-- ALGOLIA VIEW  -->
    <div class="agentsDiv mainContentBox" [ngClass]="isPairedAgentAvailable">

      <!-- PAIRED AGENTS -->

      <div class="paired-agents-div" *ngIf="(userData.subscriptionStatus === 'active' || 
        userData.subscriptionStatus === 'past_due' || 
        userData.regionalLender || 
        userData.role === 'agentAdmin') && showPairedAgentsDiv">
        <div class="text-button-container">
          <label class="pairedAgentsLabel">Paired Agents</label>

          <ion-icon *ngIf="userData.enableAgentsListingsResultsFiltering === true" class="filterIcon"
            name="options-outline" tappable (click)="toggleFilterVisbility()"></ion-icon>
        </div>

        <div *ngIf="userData && eligibleStatesLoaded && instanceNameAdvancedSearch">
          <algolia-search-with-filters [instanceName]="instanceNameAdvancedSearch"
            [childComponent]="algoliaAgentSearchWithFilters" [noResultsMessage]="'No paired agents found.'"
            [restrictStates]="userData.regionalLender" [restrictToStates]="eligibleStates"
            [locationData]="['locations.lvl0', 'locations.lvl1', 'locations.lvl2']" />

          <ng-template #algoliaAgentSearchWithFilters let-hit>
            <app-public-profile-item [showControls]="true" [showContact]="true" [attr.data-index]="i"
              class="listing-item hit-border" [pairedAgentData]="hit" [canImpersonate]="canImpersonate" />
          </ng-template>
        </div>
      </div>

      <div *ngIf="!isMobilePhone" class="spacer-15"></div>

      <div class="pair-agent-div">
        <app-floating-paired-item [hideInviteButton]="true"
          [noResultsMessage]="'Agent not found but still can be invited to Curb Hero'" type="agent"
          *ngIf="!loading && !userData.regionalLender && pairingLink" [pairingLink]="pairingLink" />

       
        <!-- INVITE AGENTS FOR ADMINS -->
        <div *ngIf="userData.role === 'agentAdmin'" class="parentAgentDiv">

          <div *ngIf="myInvitedAgents.length && userData.subscriptionStatus === 'active'" class="pairDivHeader">

            <label>Agent Invitations</label>

          </div>



          <div *ngIf="myInvitedAgents.length">
            <div class="spacer-10"></div>

            <div *ngFor="let inviteObj of myInvitedAgents; let i = index" class="agentComponent borderBox">

              <app-public-profile-item [showControls]="true" [attr.data-index]="i" class="listing-item"
                [user]="inviteObj" (onEvents)="listingEvents($event)" [showContact]="false" [showInvite]="false">
              </app-public-profile-item>

            </div>

          </div>

        </div>

        <!-- RECOMMENDED AGENTS -->
        <div *ngIf="!userData.regionalLender && userData.role !== 'agentAdmin'" class="parentAgentDiv">
          <div
            *ngIf="myInvitedAgents.length || userZipcode || userData.subscriptionStatus === 'active' || userData.subscriptionStatus === 'past_due'"
            class="pairDivHeader">

            <ion-label>Recommended Agents</ion-label>

            <!-- CURRENT ZIP CODE VIEW -->
            <div class="link zipCodeDiv grey-message-area" *ngIf="currentLocationView === 'currentZipCodeView'"
              (click)="enterLocation()">

              <ion-icon name="location-outline"></ion-icon>

              <span class="zip" data-cy="myPairedAgents-location-enteredZipCode">{{userZipcode}}</span>
            </div>
          </div>

          <div class="spacer-10"></div>

          <div *ngIf="myInvitedAgents.length">

            <div *ngFor="let inviteObj of myInvitedAgents; let i = index" class="agentComponent borderBox">

              <app-public-profile-item [showControls]="false" [attr.data-index]="i" class="listing-item"
                [user]="inviteObj" (onEvents)="listingEvents($event)" [showContact]="false" [showInvite]="true">
              </app-public-profile-item>

            </div>
          </div>

          <!-- ENTER LOCATION-->
          <div class="noAgentsDiv blockBox centerBox centerAlign" *ngIf="currentLocationView === 'enterZipCodeView'">

            <p class="infoText" data-cy="myPairedAgents-location-title">
              Enter your location to see nearby agents using Curb Hero</p>

            <img src="/assets/imgs/addLenderZipCode.png" data-cy="myPairedAgents-location-icon" />

            <p class="helpText" data-cy="myPairedAgents-location-description">Pair with nearby agents using Curb Hero.
              <br /><strong class="link" (click)="learnMore(3)">Learn More</strong>
            </p>

            <div class="full-width centerAlign">

              <ion-button style="width:94%; max-width: 350px;" (click)="enterLocation()"
                data-cy="myPairedAgents-location-enterLocationBtn">Enter Location</ion-button>

            </div>
          </div>

          <algolia-automatic-search #algoliaAutomaticAgentSearch [instanceName]="instanceName"
            [style.display]="currentLocationView !== 'enterZipCodeView' ? 'block' : 'none'"
            noResultsMessage="No more recommended agents found." [filterHitsFn]="filterHitsFn"
            [childComponent]="hitTemplate" />

          <ng-template #hitTemplate let-hit>
            <app-public-profile-item [pairedAgentData]="hit" [showControls]="false" [showContact]="false"
              [showSocial]="false" [showInvite]="true" [searchInviteMode]="false"
              (inviteClicked)="inviteClickedFn(hit)" />
          </ng-template>
        </div>

        <!-- NO ACTIVE SUBSCRIPTION VIEW -->
        <div *ngIf="!showRefresh && (userData.subscriptionStatus !== 'active' && !userData.regionalLender)">
          <div *ngIf="!loading">
            <div class="spacer-20"></div>
            <div class="noAgentsDiv blockBox centerBox centerAlign">
              <div class="spacer-20"></div>
              <div class="spacer-20"></div>
              <div>
                <p *ngIf="userData.role === 'agentAdmin'" class="infoText firaSans"
                  data-cy="myPairedAgents-selectPlan-title">Manage your entire team's Open
                  House prospecting and more!</p>

                <p *ngIf="userData.role === 'lender'" class="infoText firaSans"
                  data-cy="myPairedAgents-selectPlan-title">Get in front of buyers that are
                  actively looking at property</p>

              </div>
              <img src="/assets/imgs/noPairedAgent.png" data-cy="myPairedAgents-selectPlan-icon" />

              <p *ngIf="userData.role === 'lender'" class="helpText" data-cy="myPairedAgents-selectPlan-description">To
                pair with your partner agents or any of the thousands of other agents on our platform, you need to
                select a subscription plan. <strong class="link" (click)="learnMore(1)">Learn
                  More</strong>
              </p>

              <p *ngIf="userData.role === 'agentAdmin'" class="helpText"
                data-cy="myPairedAgents-selectPlan-description">
                See lead activity, manage branding,
                create accounts, and assign listings across the entire team. Try for free for 30 days.
                <strong class="link" (click)="learnMore(4)">Learn
                  More</strong>
              </p>

              <ion-button ion-button tappable color="primary" (click)="openMySubscription()"
                data-cy="myPairedAgents-selectPlan-selectPlanBtn">Select Plan</ion-button>
            </div>
            <div class="noAgentsDiv blockBox centerBox centerAlign" *ngIf="userData.role === 'lender'">
              <div class="spacer-20"></div>
              <div class="spacer-20"></div>
              <div *ngIf="!userData.webPublished">
                <p class="infoText firaSans">Not ready to select a plan yet?</p>
              </div>
              <div *ngIf="!userData.webPublished">
                <img src="/assets/imgs/selectPlan.png" />
                <p class="helpText">You can still use My Link and the Dynamic QR Code for FREE. Engage prospects with a
                  branded, mobile optimized microsite that you can change anytime! <strong (click)="learnMore(2)">Learn
                    More</strong></p>

                <ion-button ion-button outline tappable (click)="openMicrosite()">Claim My Link for Free</ion-button>
              </div>
              <div class="spacer-20"></div>
              <div class="spacer-20"></div>
            </div>
            <div class="spacer-20"></div>
          </div>
          <div class="spacer-20"></div>
        </div>

        <div *ngIf="userData.subscriptionStatus === 'active' && userData.role !== 'agentAdmin'">
          <p class="pairAgentFooter" data-cy="myPairedAgents-invitationLink-footer">Additional fees per paired
            agent may
            apply. Check <strong class="link" (click)="openMySubscription()">Subscription</strong> for more
            info. </p>
        </div>

      </div>

      <div *ngIf="!isMobilePhone" class="spacer-15"></div>

      <div class="agents-create-team createAccount"
        *ngIf="(userData.subscriptionStatus === 'active' && userData.role === 'agentAdmin')">
        <ion-label>
          Setup Curb Hero Accounts for your Team
        </ion-label>
        <ion-button class="createagentButton" (click)="createAgentAccounts()">Create Agent Accounts</ion-button>
        <div *ngIf="userData.subscriptionStatus === 'active'">
          <p class="pairAgentFooter" data-cy="myPairedAgents-invitationLink-footer">Additional fees per paired
            agent may
            apply. Check <strong class="link" (click)="openMySubscription()">Subscription</strong> for more
            info. </p>
        </div>
      </div>
    </div>


    <div class="spacer-20"></div>
  </div>


  <div class="spacer-20"></div>

  <!-- REFRESH VIEW -->
  <div class="myPairedAgents" *ngIf="loadFailed">
    <div class="spacer-20"></div>
    <div class="noAgentsDiv blockBox centerBox centerAlign">
      <div class="spacer-20"></div>
      <ion-button ion-button (click)="refreshPage()" *ngIf="loadFailed">Refresh</ion-button>

      <!-- <div class="loading-container ion-text-center" *ngIf="showRefresh">
        
        <ion-spinner name="crescent"></ion-spinner>
      </div> -->

    </div>
  </div>



  <!-- <div *ngIf="loading" class="skeleton-holder">
    <div class="loadingDiv blockBox centerBox centerAlign">
      <ion-label>Loading</ion-label>
      <div class="padding">
        <ion-spinner name="crescent"></ion-spinner>
      </div>
    </div>
  </div> -->


</ion-content>